import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import {
  CUSTOM_ATTRIBUTE_TEMPLATE_URL,
  GET_CUSTOM_ATTRIBUTE_TEMPLATES_BY_EVENT_TYPE
} from '@/constants';
import { CustomAttributeType } from '@/enums';
import { apiUrl } from '@/helpers';

const customAttributeTemplateEndpoints = {
  getCustomAttributeTemplates: (eventTypeId: number, customAttributeType: CustomAttributeType) =>
    axios.get(
      `${apiUrl()}${CUSTOM_ATTRIBUTE_TEMPLATE_URL}/eventType/${eventTypeId}/customAttributeType/${customAttributeType}`
    )
};

export const useGetCustomAttributeTemplatesByEventType = (
  eventTypeId: number,
  customAttributeType: CustomAttributeType
) => {
  return useQuery(
    [GET_CUSTOM_ATTRIBUTE_TEMPLATES_BY_EVENT_TYPE, { eventTypeId, customAttributeType }],
    () =>
      customAttributeTemplateEndpoints.getCustomAttributeTemplates(
        eventTypeId,
        customAttributeType
      ),
    { enabled: !!eventTypeId && eventTypeId !== -1 }
  );
};
